(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvToolTip', drvToolTip);

    drvToolTip.$inject = ['$uibTooltip'];
    
    /**
     * These directives are WRAPPERS of Angular UI Bootstrap tooltip functionality.
     *
     * $uibTooltip is the tooltip provider in Angular UI Bootstrap.
     * We "wrap" this in our own set of directives so:
     * a) It's easier to replace the Angular UI Bootstrap aspect if necessary.
     * b) There is a common code path for common aspects of tooltip configuration, so we can give a consistent experience.
     *
     * The 'popup' directives are specifically named to correspond with the tooltip directives, these are used
     * internally by the tooltip and are *not* intended for direct use.
     */

    /**
     * A HTML tooltip that displays when the element is hovered on.
     *
     * Must be used as an attribute, content of attribute is an expression.
     * E.g. <div drv-tool-tip="'Hello <strong>tooltip</strong> world'"></div>
     */
    function drvToolTip($uibTooltip) {
        return $uibTooltip('drvToolTip', 'tooltip', 'mouseenter', {
            useContentExp: true,
            popupDelay: 500,
            appendToBody: true,
            placement: 'auto top'
        });
    }


    angular
    .module('app')
    .directive('drvToolTipOnClick', drvToolTipOnClick);

    drvToolTipOnClick.$inject = ['$uibTooltip'];

    /**
     * A HTML tooltip that displays when the element is clicked and hides when clicked outside.
     *
     * Must be used as an attribute, content of attribute is an expression.
     * E.g. <div drv-tool-tip-on-click="'Hello <strong>tooltip</strong> world'"></div>
     */
    function drvToolTipOnClick($uibTooltip) {
        return $uibTooltip('drvToolTipOnClick', 'tooltip', 'mouseenter', {
            useContentExp: true,
            appendToBody: true,
            placement: 'auto top'
        });
    }


    angular
        .module('app')
        .directive('drvToolTipPopup', drvToolTipPopup);

    /**
     * Popup for tooltip.
     * Internal use only.
     */
    function drvToolTipPopup() {
        return {
            replace: true,
            scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
        };
    }

    angular
        .module('app')
        .directive('drvToolTipOnClickPopup', drvToolTipOnClickPopup);

    /**
     * Popup for tooltip.
     * Internal use only.
     */
    function drvToolTipOnClickPopup() {
        return {
            replace: true,
            scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
        };
    }
})();